import { Select } from 'antd'
import React, { useState } from 'react'

export default function MultiSelect({options,value, onChangeFunc, placeholder,width,size}) {
    const handleChange = (value) => {
      onChangeFunc(value)
      };
  return (
    <>
    <Select 
    size={size === undefined ? 'medium' : size}
    mode="multiple"
    allowClear
    options={options}
    style={width === undefined ? { width: '260px'}  : {width}}
    placeholder={placeholder === undefined ? 'Select' : placeholder}
    onChange={handleChange}
    value={value}
    optionLabelProp="label"
      filterOption={(input, option) =>
        option?.label.toLowerCase().includes(input.toLowerCase())
      } 
    maxTagCount={0}  // Hide the tags
    maxTagPlaceholder={`${value.length} Selected`}  // Custom placeholder
    />
    </>
  )
}
